<template>
  <div class="card-type" :style="[styleObject, overWriteStyle]" >
    <div class="card-head" v-if="$slots.head">
      <slot name="head"></slot>
    </div>
    <div class="card-content zoom" :class="{'card-content-withHead':$slots.head}">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    name: 'card',
    data(){
      return {
      }
    },
    props: {
      size: {
        type: String,
        default: 'normal' // 'large','max'
      },
      styleObject: {
        type: Object,
        default(){
          return {}
        }
      },
      stylePostion: {
        type: String,
        default: 'absolute'
      }
    },
    computed: {
      overWriteStyle(){
        return {width: this.styleObject.width || (this.enums[this.size].width + 'rem'), height: this.styleObject.height || (this.enums[this.size].height + 'rem')}
      },
      ...mapState({
        'enums': 'indexCardsSize'
      })
    }
  }
</script>
<style lang="less">
   @import '../../assets/less/base.less';

  @card-width: 290px;
  @card-height: 416px;
  @card-margin: 10px;
  .card-type{
    position:absolute;
    left:0;
    top:0;
    z-index: 10;
  }
  .card-head{
    font-size: @font-size-normal;
    text-align: center;
  }
  .card-content{
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// card.vue?e2c58ab4